import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import styled from 'styled-components';

interface CardPaymentPlan {
  paymentPlan: {
    downPayment: number | string | null;
    years: number;
    price: number;
    currency: string;
    installment: string | null;
  };
}
const CardPaymentPlan = ({ paymentPlan }: CardPaymentPlan) => {
  const { t } = useTranslation(['search', 'common']);
  const { locale, ...router } = useRouter();

  const highlightText = router.asPath === '/affordability-results';

  return (
    <Container>
      <div className="down-payment-container">
        <span className="down-payment">
          {paymentPlan?.installment ? (
            <>
              {paymentPlan.installment} {paymentPlan.currency}{' '}
              {t('monthly', { ns: 'common' })}
            </>
          ) : (
            paymentPlan?.downPayment && (
              <>
                {locale === 'ar' && (
                  <span className={highlightText ? 'highlight' : ''}>
                    {t('down_payment')}
                  </span>
                )}{' '}
                {paymentPlan?.downPayment}{' '}
                {locale === 'en' && (
                  <span className={highlightText ? 'highlight' : ''}>
                    {t('down_payment')}
                  </span>
                )}
              </>
            )
          )}{' '}
          {((paymentPlan?.downPayment && paymentPlan?.years) ||
            (paymentPlan?.installment && paymentPlan?.years)) && (
            <span>/</span>
          )}{' '}
          {paymentPlan?.years && (
            <span>
              {paymentPlan?.years}{' '}
              <span className={highlightText ? 'highlight' : ''}>
                {t('years')}
              </span>
            </span>
          )}
        </span>
      </div>

      <div className="price-container">
        {paymentPlan?.price ? (
          <>
            <span className="price">
              {`${paymentPlan?.price?.toLocaleString()} 
              ${t(paymentPlan?.currency)}`}
            </span>
            <span className={`start-price ${highlightText && 'highlight'}`}>
              {t('start_price')}
            </span>
          </>
        ) : (
          <span className="price">{t('price_tba', { ns: 'common' })}</span>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .highlight {
    color: #ff5e00;
    font-family: materialSemiBold;
  }

  .down-payment-container {
    .down-payment {
      color: #1a2028;
      font-size: 12px;
      font-family: materialRegular;
    }
  }

  .price-container {
    display: flex;
    align-items: center;
    gap: 4px;

    .price {
      color: #1a2028;
      font-size: 17px;
      font-family: materialBold;
    }

    .start-price {
      color: #5b6573;
      font-size: 12px;
      font-family: materialRegular;

      &.highlight {
        color: #ff5e00;
      }
    }
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    .down-payment-container {
      .down-payment {
        font-size: 11px;
      }
    }

    .price-container {
      .price {
        font-size: 21px;
      }

      .start-price {
        font-size: 11px;
      }
    }
  }
`;

export default CardPaymentPlan;
